import { Sparkles } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";

export const ScoreBadge = ({ score, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1 px-2 py-0.5 font-mono text-xs font-semibold ${score >= 80 ? "bg-orange-500 text-white" : "border border-sky-400/40 text-sky-300"}`}>
    {score >= 80 && <Sparkles className="h-3 w-3" />}{score}% {score >= 80 ? "Top Match" : "Shortlisted"}
  </span>
);

export const MatchAlert = ({ open, count, lines, onView }) => (
  <Dialog open={open} onOpenChange={(o) => { if (!o) onView(); }}>
    <DialogContent data-testid="instant-match-dialog" className="rounded-none border-orange-500/40 bg-[#0F172A] text-slate-100">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2 font-heading text-2xl text-white">
          <Sparkles className="h-6 w-6 text-orange-400" />Instant Match
        </DialogTitle>
        <DialogDescription data-testid="instant-match-count" className="text-slate-300">
          {count} new match{count > 1 ? "es" : ""} found for you.
        </DialogDescription>
      </DialogHeader>
      <ul className="space-y-2">
        {lines.slice(0, 4).map((l) => (
          <li key={l.id} className="flex items-center justify-between gap-3 border border-white/10 px-3 py-2 text-sm">
            <span>{l.text}</span><ScoreBadge score={l.score} />
          </li>
        ))}
      </ul>
      <button onClick={onView} data-testid="instant-match-view-button" className="mt-2 w-full bg-orange-500 py-2.5 font-semibold text-white hover:bg-orange-600">
        View matches
      </button>
    </DialogContent>
  </Dialog>
);
